import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";
import { api } from "../lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const bid = sp.get("booking_id");
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sid) { setStatus("unknown"); return; }
    let t;
    const check = async () => {
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") setStatus("paid");
        else if (attempts >= 20) setStatus("timeout");
        else { setAttempts(a=>a+1); t = setTimeout(check, 2000); }
      } catch { setStatus("error"); }
    };
    check();
    return () => t && clearTimeout(t);
  }, [sid, attempts]);

  return (
    <PublicLayout>
      <section className="max-w-md mx-auto px-4 pt-16 pb-24 text-center">
        {status==="paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-600 mx-auto" />
            <h1 className="text-3xl font-display font-black mt-4">Payment received!</h1>
            <p className="text-slate-500 mt-2">Booking {bid} is confirmed and paid.</p>
          </>
        ) : (
          <>
            <Loader2 className="w-16 h-16 text-[#ea580c] mx-auto animate-spin" />
            <h1 className="text-2xl font-display font-black mt-4">Confirming payment…</h1>
            <p className="text-slate-500 mt-2">This can take a few seconds. Please don&apos;t close the tab.</p>
          </>
        )}
        {bid && <Link to={`/book/confirm/${bid}`} className="inline-block mt-6 px-5 py-2.5 rounded-md bg-[#1e1b4b] text-white font-semibold" data-testid="back-to-booking">Back to booking</Link>}
      </section>
    </PublicLayout>
  );
}
